function safeJsonParse(value) {
  try { return JSON.parse(value) } catch { return null }
}

const FINAL_EVENTS = new Set(['workflow_completed', 'clarification_needed'])

export function parseHermesSseEvent(raw) {
  const data = raw
    .split(/\r?\n/)
    .filter((line) => line.startsWith('data:'))
    .map((line) => line.slice(5).trimStart())
    .join('\n')
    .trim()
  return data ? safeJsonParse(data) : null
}

export function applyHermesEvent(acc, event) {
  if (!event || typeof event !== 'object') return
  if (event.runId) {
    acc.run = {
      runId: event.runId,
      status: event.status || acc.run?.status || 'running',
      statusUrl: event.statusUrl || acc.run?.statusUrl || `/api/hermes/runs/${event.runId}`,
    }
  }
  if (FINAL_EVENTS.has(event.type)) {
    acc.result = event.result || null
    return
  }
  if (event.type === 'error') {
    acc.error = event.error || event.content || 'Hermes workflow failed.'
    if (event.result) acc.result = event.result
  }
}

export function drainHermesSseBuffer(acc, buffer, final = false, onEvent) {
  let next = buffer
  let boundary = next.indexOf('\n\n')
  while (boundary >= 0) {
    const event = parseHermesSseEvent(next.slice(0, boundary))
    if (event && typeof onEvent === 'function') onEvent(event)
    applyHermesEvent(acc, event)
    next = next.slice(boundary + 2)
    boundary = next.indexOf('\n\n')
  }
  if (final && next.trim()) {
    const event = parseHermesSseEvent(next)
    if (event && typeof onEvent === 'function') onEvent(event)
    applyHermesEvent(acc, event)
    return ''
  }
  return next
}
